export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-3 mb-2">
            <span className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-lg">
              <i className="ri-mail-send-line text-background-50 text-xl"></i>
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">联系我们</h2>
          </div>
          <p className="text-foreground-500 text-sm mb-10">
            欢迎爆料投稿与合作咨询 · 黑料在线期待您的来信
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 mx-auto mb-3">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">爆料投稿</h3>
              <p className="text-xs text-foreground-500">tips@heiliao.com</p>
            </div>
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 mx-auto mb-3">
                <i className="ri-briefcase-line text-accent-600 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">biz@heiliao.com</p>
            </div>
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 mx-auto mb-3">
                <i className="ri-shield-check-line text-secondary-600 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">侵权投诉</h3>
              <p className="text-xs text-foreground-500">report@heiliao.com</p>
            </div>
          </div>

          <p className="text-xs text-foreground-500">
            如需获取黑料在线最新动态，请收藏本站并关注黑料在线观看更新。
            <br />
            所有投稿信息严格保密，爆料人身份绝对匿名。
          </p>
        </div>
      </div>
    </section>
  );
}